export default __webpack_public_path__ + "static/media/pdf.eb53b17a.png";